import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import styled from "styled-components";
import { token } from "./token.js";
import { useZIndex } from "./useZIndex.js";
const Container = forwardRef(({
  children,
  noPadding = false,
  ...props
}, ref) => {
  const zIndex = useZIndex("popover");
  return /* @__PURE__ */ jsx(ContainerStyled, {
    role: "dialog",
    ref,
    $zIndex: zIndex,
    $noPadding: noPadding,
    tabIndex: -1,
    ...props,
    children
  });
});
const ContainerStyled = styled.div.withConfig({
  displayName: "ContainerStyled",
  componentId: "sc-gfw5yz-0"
})(["z-index:", ";overflow-y:auto;box-sizing:border-box;padding:", ";border-radius:", ";background:", ";color:", ";box-shadow:", ",", ";&:focus{outline:none;}"], (props) => props.$zIndex, (props) => props.$noPadding ? 0 : `${token.spacing3} ${token.spacing5}`, token.radiusBase, token.gray10, token.colorText, token.elevationStatic, token.elevation2);
export {
  Container
};
//# sourceMappingURL=Container2.js.map
